module.exports = __webpack_public_path__ + "img/theme.d62c67dd.png";